import { MAP_GEN_FILL_LAYOUT_IDS, type MapGenFillLayoutId } from '@nova/types';

import type { GenerateFillLayoutOptions, TileLayoutResult } from '../tile-layout-types';

import { generateAngledWallsAndStripsLayout } from './angled-walls-and-strips-layout';
import { generateAxisAlignedGappedStripsLayout } from './axis-aligned-gapped-strips-layout';
import { generateDiagonalBiasedWallsLayout } from './diagonal-biased-walls-layout';
import { generateGapAwareOrganicWallsLayout } from './gap-aware-organic-walls-layout';
import { generateOpenLayout } from './open-layout';
import { generateSingleRightAnglesAndLinesLayout } from './single-right-angles-and-lines-layout';

type FillLayoutGenerator = (options: GenerateFillLayoutOptions) => TileLayoutResult;

const FILL_LAYOUT_BY_ID: Record<MapGenFillLayoutId, FillLayoutGenerator> = {
  open: generateOpenLayout,
  singleRightAnglesAndLines: generateSingleRightAnglesAndLinesLayout,
  gapAwareOrganicWalls: generateGapAwareOrganicWallsLayout,
  angledWallsAndStrips: generateAngledWallsAndStripsLayout,
  axisAlignedGappedStrips: generateAxisAlignedGappedStripsLayout,
  diagonalBiasedWalls: generateDiagonalBiasedWallsLayout
};

/**
 * Runs a named fill-layout algorithm.
 * All layouts return the same {@link TileLayoutResult} shape (grid + stats + reachability carve).
 */
export function generateFillLayout(options: GenerateFillLayoutOptions): TileLayoutResult {
  return FILL_LAYOUT_BY_ID[options.layoutId](options);
}

/** Registered fill-layout ids (same set as {@link MapGenFillLayoutId}). */
export function listFillLayoutIds(): readonly MapGenFillLayoutId[] {
  return MAP_GEN_FILL_LAYOUT_IDS;
}
